export const periodsBySports = {
    'Soccer': "Half",
    'CyberFootball': 'Half',
    'Socceradditional_time': 'Additional Time',
    'Soccerpenalty': "Penalty",
    'Soccerfinished': 'Finished',
    'Boxing': "Round",
    'Tennis': "Set",
    'IceHockey': "Period",
    'EBasketball': "Quarter",
    'Basketball': "Quarter",
    'Volleyball': "Set",
    'Handball': "Half",
    'Baseball': "Inning",
    'BeachVolleyball': "Set",
    'BeachSoccer': "Period",
    'Rugby': "Time",
    'Snooker': "Frame",
    'AmericanFootball': "Quarter",
    'AustralianFootball': "Quarter",
    'WaterPolo': "Period",
    'MiniSoccer': "Time",
    'BallHockey': "Period",
    'TableTennis': "Set",
    'Badminton': "Game",
    'Squash': "Game",
    'Netball': "Quarter",
    'Dota': "Game",
    'Dota2': "Game",
    'CounterStrike': "Map",
    'Hearthstone': "Game",
    'LeagueOfLegendsset': "Game",
    'StarCraft': "Map",
    'set': "Set",
    'RugbySevens': "Half",
    'RugbyLeague': "Half",
    'RugbyUnion': "Half",
    'HeroesOfTheStorm': "Map",
    "Cricket": "Set",
    "Hockey": "Set",
    "LeagueOfLegends": "Game",
    "ETennis": "Set",
    "MortalKombatXL": "Game",
    "3x3 Basketball": "Quarter",
    "Overwatch": "Game",
    "Floorball": "Game",
    'Darts': "Game"
};

export const mapEventNames = {
    "W1": "P1",
    "W2": "P2"
};

export const firstHalf = ['HalfTimeResult', 'HalfTimeAsianHandicap', 'HalfTimeOverUnder', 'HalfTimeCorrectScore'];
export const secondHalf = ['SecondHalfResult', '2ndHalfAsianHandicap', '2ndHalfTotalOver/Under', '2ndHalfCorrectScore'];
export const activeSequences = ['MATCH', 'HALF', 'SET', "ODD/EVEN"];